import { ButtonVariant, ButtonView } from "common/views/button/Button.view";
import { IDataFragment } from "core/components/FragmentProvider";
import { IUserRegistrationFragmetProps } from "./UserRegistrationForm.panel";
import React from "react";
import Label from "core/components/label/Label";
import styled from "styled-components";
import ServiceRegistry from "core/util/ServiceRegistry";
import XHRResolverService from "core/service/resolver/impl/XHRResolver.service";
import { Intent } from "@blueprintjs/core";
import { ForumToaster } from "panels/forum/forumActions";

const StyledDiv = styled.div`{
	display: flex;
    justify-content: flex-start;
    padding: .5em;
    width: 50%;
	& > span{flex: 2}
	& >div{flex: 1}
}`;

export const sumbit: IDataFragment<IUserRegistrationFragmetProps> = {
	name: "sumbit",
	label: {},
	component: ({state, onErroStateChange, errorStateRest}) => {
		
		const getMutationQuery=(user: any)=>{
			let params:string= "mutation { createUser(params: { ";
			let entries = Object.entries(user)
			entries.map( ([key, val]) => {
				if(typeof val === "string"){
					params = params + key+":\""+val+"\", ";
				} else if(Array.isArray(val)){
					params = params + key+":["+val+"], ";
				}
				else  params = params + key+": "+val+", "; 
			  });

			  //setting properties
			  params = params+ "properties: [";
			  state.properties&& Object.entries(state.properties).map(([key, val]) => {
				let propsVal =val['property']
				if(val && propsVal){			
					params= params+ `{ value:"${val['value']}", propertyId: ${propsVal['id']} }`;
				}
			  });
			  params= params+"]";
	
			  params= params+ " }) { entityId } } ";
			  return params;
		}

		const validatedData=()=>{
			errorStateRest();
			let validate= true;
			let user= state.user;
			if(!user) return false;
			if(isNullorEmpty(user['username'])) {
				onErroStateChange("username", true); 
				validate=false;
			} if(isNullorEmpty(user['firstName'])) {
				onErroStateChange("firstName", true);
				validate=false;
			} if(isNullorEmpty(user['email'])) {
				onErroStateChange("email", true);
				validate=false;
			} if(isNullorEmpty(user['lastName'])) {
				onErroStateChange("lastName", true);
				validate=false;
			} if(isNullorEmpty(user['confirmPassword']) || isNullorEmpty(user['password']) || user['password'] !== user['confirmPassword']){
				onErroStateChange("password", true);
				validate=false;
			}
			return validate;
		}

		const isNullorEmpty=(...values)=>{
			for(var i = 0; i < values.length; i++) {
				if (!values[i] || values[i] == undefined || values[i] == "" || values[i].length == 0){
					return true
				}
			  }
			  return false;	
		}
		  
		const onSubmit=()=>{
			if(!validatedData()) return;
			const resolver = ServiceRegistry.get(XHRResolverService);
			const mutation = getMutationQuery(state.user);
			
			resolver.execute(mutation).then(req => {
				
				let reqData= JSON.parse(req);
				let data= reqData.data;
				if(reqData.errors){
					ForumToaster.show({
						intent: Intent.DANGER,
						message: "Error While User Creation"
					});
				} else if(data['createUser']){
					ForumToaster.show({
						intent: Intent.SUCCESS,
						message: "User Creation Successful!!"
					});
				}
			 }).catch(err => {
				console.log(err);
			 });
		}

		return(
		<StyledDiv>
			<ButtonView
				variant={ButtonVariant.PRIMARY}
				viewKey="userRegistrationForm.sumbit"
				onClick={onSubmit}
			>
				<Label k="userRegistrationForm.sumbitButton" v="Sumbit"/> 
			</ButtonView>
		</StyledDiv>
	)}
};


// WEBPACK FOOTER //
// ./src/panels/userRegistration/actionFragments.tsx